import FieldConfig from "../../../proto/field-config";
import FieldIcon from "../../../generic/icon/icon";
import FieldGoalIcon_View from "./render/view";

export default class FieldGoalIcon extends FieldIcon {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                      = "Goal icon";

        this.renderComponents.view          = FieldGoalIcon_View
    }

    // return icon class
    getDisplayValue(value: any): any {
        return super.getDisplayValue(value);
    }
}
